import { Component } from '@angular/core';
import { CONSUMER_ACCESS_URL } from 'src/utilities/constants/misc.constants';
import { version } from '../../../../package.json';

@Component({
  selector: 'maintenance-footer',
  templateUrl: './maintenance-footer.component.html'
})
export class MaintenanceFooterComponent {
  public version: string = version;
  public dialogOptions = { externalUrl: CONSUMER_ACCESS_URL };

  constructor() { }

}
